import {Image, Text} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

import {isNil} from 'ramda';

interface AuctionServerLogoProps {
  server: string;
  serverName?: string;
}

const mapAuctionServerToLogo = (server: string): string | null =>
  match<string, string | null>(server)
    // ALD Automotive – DK, CZ, SE, LT, EE, LV, DE, BE, IT, AT, LU, FR
    .with(
      Pattern.union(
        'cdh-39',
        'cdh-44',
        'cdh-45',
        'cdh-46',
        'cdh-48',
        'cdh-49',
        'cdh-53',
        'cdh-64',
        'cdh-65',
        'cdh-66',
        'cdh-67',
        'cdh-68'
      ),
      () => 'ald_automotive.svg'
    )
    // Arval – SK, CZ, SE, BE, NL, DE, FR, IT
    .with(
      Pattern.union('cdh-73', 'cdh-74', 'cdh-75', 'cdh-76', 'cdh-77', 'cdh-78', 'cdh-81', 'cdh-82'),
      () => 'arval.png'
    )
    // Athlon – NL, IT, PL, BE, DE, FR
    .with(
      Pattern.union('cdh-4', 'cdh-58', 'cdh-59', 'cdh-60', 'cdh-63', 'cdh-113'),
      () => 'athlon.svg'
    )
    // Autorola / Ex-lease & Fleet / Ex-Leasing vehicles – CDH/Autorola platform
    .with(
      Pattern.union(
        'cdh-166',
        'cdh-167',
        'cdh-168',
        'cdh-169',
        'cdh-170',
        'cdh-171',
        'cdh-172',
        'cdh-175',
        'cdh-34',
        'cdh-117',
        'cdh-144'
      ),
      () => 'autorola.png'
    )
    // VW Pon Financial Services – NL
    .with('cdh-6', () => 'vw_pon_fs.svg')
    // Alphabet Netherlands – NL
    .with('cdh-5', () => 'alphabet.svg')
    // Broekhuis Lease – NL
    .with('cdh-9', () => 'broekhuis.svg')
    // MHC Mobility – NL
    .with('cdh-10', () => 'mhc_mobility.png')
    // Hiltermann Lease – NL
    .with('cdh-15', () => 'hiltermann.png')
    // International Car Lease Holding – NL, BE
    .with(Pattern.union('cdh-7', 'cdh-29'), () => 'iclh.svg')
    // Friesland Lease – NL
    .with('cdh-11', () => 'friesland-lease.svg')
    // Janssen Van Kouwen – NL
    .with('cdh-30', () => 'jvk.svg')
    // KBC – BE
    .with('cdh-57', () => 'kbc.svg')
    // Sparkassen-Finanzgruppe – DE
    .with('cdh-92', () => 'sparkassen.svg')
    // D'Ieteren – BE
    .with('cdh-90', () => 'dIeteren.svg')
    // kvdcars – SE
    .with('cdh-93', () => 'kvdcars.png')
    // LeasePlan Netherlands – NL
    .with('cdh-118', () => 'leaseplan.svg')
    // Santander Leasing – NL
    .with('cdh-143', () => 'santander.svg')
    // AUTOBID – DE
    .with('cdh-145', () => 'autobid.svg')
    .otherwise(() => null);

export function AuctionServerLogo({server, serverName}: AuctionServerLogoProps) {
  const logo = mapAuctionServerToLogo(server);

  if (isNil(logo)) {
    return <Text size="small">{serverName ?? server}</Text>;
  }

  return (
    <Image
      src={`/assets/images/auction-server-logo/${logo}`}
      alt={serverName ?? server}
      maxHeight={8}
      maxWidth={32}
    />
  );
}
